/**
 * @description 保險金分配方式 (enum)
 */
export enum InsuranceAmountAllocateTypesEnum {
  /** 順位 */
  Precedence = 'prec',
  /** 比例 */
  Proportion = 'prop'
}
